module.exports = __webpack_public_path__ + "static/media/video.c4b44e1f.svg";